const hostname = window && window.location && window.location.hostname;

let adminApiHost = 'menu.dev-saucey-api2.com';
let environment = "dev";
let algoliaApp = "8C9YGK8FUZ";
let algoliaKey = "3db066007957c6d4727965e34d664a72";
let algoliaIndex = "SCY_development";
let typesenseHost = "search.saucey.io";
let typesenseKey = "ml9xXtMniuEEPU2gAADZKHT2qv5CLsem";
let typesenseCollection = "development_products"
if (!!process.env.REACT_APP_API_ENV) {
  switch (process.env.REACT_APP_API_ENV) {
    case 'local':
      adminApiHost = 'localhost:1234';
      environment = "local"
      break;
    case 'typesense':
    case 'development':
      adminApiHost = 'menu.dev-saucey-api2.com'
      environment = "dev"
      break;
    case 'ts-prod':
    case 'production':
      adminApiHost = 'menu.saucey-api2.com';
      environment = "prod"
      algoliaApp = "KMCVQEY5JL";
      algoliaKey = "21e7c0a74eb782cb5d982b37bf88e5a3";
      algoliaIndex = "SCY_production";
      typesenseCollection = "production_products"
      break;
    default:
      break;
  }
} else {
  if (hostname.includes('local') && process.env.REACT_APP_API_ENV !== 'local') {
    adminApiHost = 'localhost:1234';
    environment = "local"
  }
  if (hostname.includes('dev') || hostname.includes('typesense')) {
    adminApiHost = 'menu.dev-saucey-api2.com';
    environment = "dev"
  } else {
    adminApiHost = 'menu.saucey-api2.com';
    environment = "prod"
    algoliaApp = "KMCVQEY5JL";
    algoliaKey = "21e7c0a74eb782cb5d982b37bf88e5a3";
    algoliaIndex = "SCY_production";
    typesenseCollection = "production_products"
  }
}
// Use http:// for localhost, otherwise use protocol-relative URL
export const ADMIN_API_ROOT = adminApiHost.includes('localhost') 
  ? `http://${adminApiHost}` 
  : `//${adminApiHost}`;
export const APP_LOGO = "https://web.saucey.com/dist/images/c5ca5259d190b9cd96475c4e10f5ea61.svg";
export const APP_NAME = "Saucey";
export const LOGIN_SCHEME = "username";
export const AUTH_BG = "https://cc.heyemjay.com/static/media/background-2.e2e637ac.jpg";
export const ALGOLIA_APP = algoliaApp;
export const ALGOLIA_KEY = algoliaKey;
export const ALGOLIA_INDEX = algoliaIndex;
export const TYPESENSE_HOST = typesenseHost;
export const TYPESENSE_KEY = typesenseKey;
export const TYPESENSE_COLLECTION = typesenseCollection;
